import React from 'react';

const CLOSE_ICON = '/assets/popup/close.svg';
const COMPLETE_ICON = '/assets/popup/check.svg';

interface SuccessPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SuccessPopup({ isOpen, onClose }: SuccessPopupProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative w-[454px] rounded-[16px] bg-[#0b1019] px-6 pb-6 pt-4 shadow-[0_20px_70px_rgba(0,0,0,0.55)]">
        <div className="flex w-full items-center justify-between">
          <h2 className="text-[20px] font-medium leading-[1.5] text-white">
            Privacy Certificate Generated
          </h2>
          <button
            onClick={onClose}
            className="flex h-[20px] w-[20px] items-center justify-center transition-opacity hover:opacity-80"
          >
            <img src={CLOSE_ICON} alt="Close" className="h-full w-full" />
          </button>
        </div>

        <div className="mt-4 flex flex-col items-center gap-4">
          <div className="h-[44px] w-[44px]">
            <img src={COMPLETE_ICON} alt="Success" className="h-full w-full" />
          </div>

          <div className="flex flex-col gap-1 text-center">
            <p className="text-[24px] font-medium leading-[1.5] text-white">
              Stake successful
            </p>
            <p className="text-[12px] font-medium leading-[1.5] text-[#909090]">
              Your liquidity position to now hidden from the public mempool
            </p>
          </div>

          <button
            onClick={onClose}
            className="h-[40px] w-[120px] rounded-[8px] bg-[#39e5f5] text-[16px] font-medium leading-[1.5] text-[#090909] transition-colors hover:bg-[#32cddb]"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
